import { render, staticRenderFns } from "./PackageTypeDropdownField.vue?vue&type=template&id=3c6d04bf"
import script from "./PackageTypeDropdownField.vue?vue&type=script&lang=ts"
export * from "./PackageTypeDropdownField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c6d04bf')) {
      api.createRecord('3c6d04bf', component.options)
    } else {
      api.reload('3c6d04bf', component.options)
    }
    module.hot.accept("./PackageTypeDropdownField.vue?vue&type=template&id=3c6d04bf", function () {
      api.rerender('3c6d04bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Dropdowns/PackageTypeDropdownField.vue"
export default component.exports